//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {getScoreItems} from '@/api/vip/index';

export default {
  data() {
    return {
      itemList:[],
      userId:''
    };
  },
  methods: {
    get_score_items(){
      let param = {userId:this.userId}
      getScoreItems(param).then((res) => {
            this.itemList = res.data;
      })
    },
  },
  mounted () {
    this.userId = this.$route.query.userId;
    this.get_score_items();
  }
};



// WEBPACK FOOTER //
// ./src/pages/vip/score_detail.vue